module.exports = __webpack_public_path__ + "img/Contractor.500f143b.svg";